import React, {Component, useDebugValue, useSyncExternalStore} from 'react';
import { useState, useEffect } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col, Table, ToggleButton } from 'react-bootstrap';
import AreaN1DataService from './services/arean1.service.js';
import OrganigramaAreaDataService from './services/organigramaarea.service.js';
import UserDataService from './services/user.serviceaux.js';
import { Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import { IoAddCircle } from "react-icons/io5";
import CompetenciaDataService from './services/competencia.service.js';
import { logout } from './actions/auth.js';
import MessageBox from './MessageBox.js';
import * as AiIcons from "react-icons/ai";
import { MdCancel } from "react-icons/md";
import { AiFillCheckCircle } from "react-icons/ai";
import { GrCheckboxSelected } from "react-icons/gr";
import { BiCalendarCheck } from 'react-icons/bi';
import { FaInfoCircle } from "react-icons/fa";

function AgregarAreaN1(props) { 
  const dispatch = useDispatch();

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [Submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(props.mode);


  const [areasn1, setareasn1] = useState([]);  
  const [arean1id, setarean1id] = useState(null);  
  const [descripcionarea, setdescripcionarea] = useState("");  
  const [juezid, setjuezid] = useState(null);    
  const [users, setUsers] = useState([]);
  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]); 
  const [dispfilter, setDispFilter] = useState(true);  
  const [confirmed, setConfirmed] = useState(null);
  
  const { user } = useSelector(state => state.auth);

  useEffect(() => {
    /*
    console.log(props);
    UserDataService.getAllWithConfirmed(props.organigrama?props.organigrama.id:0)
    // asegurarse de que se imprima la lista de usuarios aquí
    .then((resp) => {
      console.log(resp.data);
      setUsers(resp.data);
    })
    .catch((err) => {
      console.error("No se pueden cargar los registros de usuario:" + err);
      console.log(err);
    })
    */

  },[])

  const onchangearean1 = (e) => {  
    console.log(e.target.value);
    const arean1id = parseInt(e.target.value);
    console.log(arean1id);
    setarean1id(arean1id);
  };

  const onchangejuez = (e) => {  
    console.log(e.target.value);
    const juezid = parseInt(e.target.value);
    console.log(juezid);
    setjuezid(juezid);
  };  
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    
    CompetenciaDataService.getCompetenciaByDescr(props.organigrama.id,"",'id','DESC')
      .then((resp) => {
        console.log(resp.data);
        console.log(resp.data.length);
        if (resp.data.length > 0) {
          console.log(props);
          //UserDataService.getAllWithConfirmed(props.organigrama?props.organigrama.id:0,0)
          UserDataService.getListaCompleta(props.organigrama.competencia[0].id, 1, "id", "ASC")
          // asegurarse de que se imprima la lista de usuarios aquí
          .then((resp) => {
            console.log(resp.data);
            setUsers(resp.data);
            setUsuariosFiltrados(resp.data.filter(usuario => usuario.sum_no_null_confirmacion_activa>0));        

            AreaN1DataService.getAreaN1ByDescr('','id','ASC')
            .then(response => {
                console.log(response.data);
                setSuccmessage('');
                setErrmessage('');
                setShowerror(false);
                setShowsuccess(false);   
                setareasn1(response.data); 
                //setarean1id(response.data[0].id);
                setLgShow(true);        
              })      
            .catch(e => {
              console.log(e);
            });        
          })
          .catch((err) => {
            console.error("No se pueden cargar los registros de usuario:" + err);
            console.log(err);
          });
        }
        else {
          alert("Por favor, asigne este organigrama a una competencia.");
          /*
          setSuccmessage('');
          setErrmessage('Por favor, asigne este organigrama a una competencia.');
          setShowerror(true);
          setShowsuccess(false);            
          */
        }          
      })
      .catch(e => {
        console.log(e);
        if (e.status === 401) {
          dispatch(logout());
        }
      }) 

  }

  let handleValidations = (e) => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    saveAreaOrganigrama();
  } 

  let saveAreaOrganigrama = (e)  =>{ 
    console.log(e.arean1id);
    console.log(e.juezid);
    let desc = (areasn1.find(obj => obj.id === parseInt(e.arean1id)) || {}).nombrearea;
    var data = {
      parentid: props.organigrama.id,
      childid: e.arean1id,
      childcategory: 'arean1',
      childdescription: desc,
      userId: juezid
    }
    
    console.log(data);
    
    OrganigramaAreaDataService.create(data)
      .then(response => {
      console.log(response.data);
      setSubmitted(true);
      handleClose();
    })
    .catch(e => {
      console.log(e);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);      
      setSuccmessage('');
      setShowsuccess(false);            
    })   
      
  }

  const onFilterUsers = (e) => {
    setDispFilter(!dispfilter);
  }

  useEffect(() => {
    if (dispfilter) {
      setUsuariosFiltrados(usuarios => usuarios.filter(usuario => usuario.sum_no_null_confirmacion_activa>0));        
    }
    else {
      setUsuariosFiltrados(users);
    }
  }, [dispfilter]);  

    return (
      <>
        <Button variant="secondary" onClick={handleShow}><IoAddCircle size={15}/></Button>      
        <Modal
          size="xl"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Agregar área N1'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(saveAreaOrganigrama)}>
              <div style={{display:'flex', flexDirection:'row', gap:'10px', alignItems:'baseline',justifyContent:'flex-start'}}>               
                <button className="btn btn-secondary" >
                  Agregar y cerrar
                </button>    
              </div>               
              <Row className='mt-2'>
                <Col className='col' md={3}>
                    <Controller
                        name="arean1id"
                        control={control}
                        onChange={onchangearean1}
                        defaultValue={arean1id}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Select
                            {...field}
                              //onChange={onchangearean1}
                              className="m-2"
                              type="select"
                              //placeholder="Nombre competencia"
                              isInvalid={errors.arean1id}
                            >
                              <option key={0} value={0}>{"Seleccionar área N1"}</option>
                              {
                                areasn1.map((row,index) => {
                                  return (
                                    <option key={index} value={row.id}>{row.nombrearea}</option>
                                  )
                                })
                              }
                            </Form.Select>
                        )}
                    />
                    {errors.arean1id && (
                        <Form.Control.Feedback type="invalid">
                            Se requiere área N1.
                        </Form.Control.Feedback>
                    )}
                </Col>  

                <Col className='col' md={3}>             
                    <Form.Select
                      onChange={onchangejuez}
                      className="mt-2"
                      type="select"
                      //defaultValue={userId}
                    >
                      <option key={0} value={null}>{"Seleccionar"}</option>
                      {
                        users.map((row,index) => {
                          var conf = " \u2b55";
                          if (row.sum_no_null_confirmacion_activa > 0) {
                            conf = ' \u2705'; // " (confirmó disponibilidad)";
                          }                             
                          var assigned = " \u2705";
                          
                          if (row.count_no_null_compid > 0) {
                            assigned = ' \u2b55'; // " (no ha sido asignado a esta competencia)";
                          } 
                          
                          return (
                            <option 
                              key={index} 
                              value={row.userid}
                              selected={parseInt(row.userid) === parseInt(juezid)}
                            >
                              
                              {
                              conf + assigned + " " +                                 
                              (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim()       
                              + " " +                                                             
                              (row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() 
                              }
                            </option>
                          )
                        })
                      }
                    </Form.Select>    

                    {/**                
                    <Controller
                      name="juezid"
                      control={control}
                      onChange={onchangejuez}
                      //defaultValue={userid}
                      defaultValue={juezid}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Form.Select
                          {...field}
                            className="m-2"
                            type="text"
                            placeholder="Primer nombre"
                            isInvalid={errors.juezid}
                            //onChange={onchangejuez}
                            //value={username}
                        >
                          <option key={0} value={0}>{"Seleccionar juez"}</option>
                          {
                            users.map((row,index) => {
                              var conf = "";
                              if (row.disponibilidad.length > 0 && row.disponibilidad[0].confirmacion_activa === 1) {
                                conf = " (confirmó disponibilidad)";
                              }
                              return (
                                <>
                                <option 
                                  key={index} 
                                  value={row.id}
                                >
                                  {(row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() 
                                  + ", " 
                                  + (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim()                                      
                                  + conf
                                  }
                                </option>
                                </>
                              )
                            })
                          }                            
                        </Form.Select>
                      )}
                    />
                    {errors.juezid && (
                      <Form.Control.Feedback type="invalid">
                        Se requiere el juez
                      </Form.Control.Feedback>
                    )}
                  */}   
                </Col>  
                <Col className='col' sm={3}>   
                  <ToggleButton className='btn btn-secondary' onClick={onFilterUsers}><BiCalendarCheck /></ToggleButton>                                                        
                </Col>
              </Row>
              <div> 
                <Table>                  
                  <TableHeader />                
                </Table>
              </div>
              <div className="table-scroll-container"> 
                <Table>                  
                  <TableBody listOf={usuariosFiltrados} onchangejuez={onchangejuez} />
                </Table>                  
              </div>              
            </Form>

            <Row className='mt-2'>

              {showerror && (
              <MessageBox show={true} showerror={showerror} errmessage={errmessage}
                onHide={() => {
                setShowerror(false)
                }}
              />
              )}
              {showsuccess && (

              <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
                onHide={() => {
                setShowsuccess(false);
                window.location.reload();
              }}
              />
              )}

            </Row>    
          </Modal.Body>
        </Modal>
      </>
    );
  }

const TableHeader = () => {
  return (
    <thead>
      <tr>
        <th style={{width:'1%'}}></th>
        <th style={{width:'1%'}}></th>
        <th style={{width:'1%'}}></th>        
        <th style={{width:'25%',textAlign:'center'}}>Juez</th>
        <th className='d-none d-sm-table-cell' style={{width:'25%'}}>Comentarios del juez</th>        
        <th className='d-none d-sm-table-cell' style={{width:'25%'}}>Area con mayor experiencia</th>
        <th className='d-none d-sm-table-cell' style={{width:'25%'}}>Area asignada</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
    if (props.listOf) {    
        const rows = props.listOf.map((row, index) => {         
        return (      
            <>
            <tr key={index}>  
            <td style={{width:'1%'}}>
              <Button 
                className='btn btn-secondary'
                style={{width:'100%',height:'100%'}}
                value={row.userid} 
                onClick={(e) => {
                  props.onchangejuez(e);
                  console.log(e.target.value);
                }}>
                {'\u2714'}
              </Button>
            </td>      
            <td style={{width:'1%'}}>
                {row.sum_no_null_confirmacion_activa > 0?"\u2705":"\u2b55"}
            </td>            
            <td style={{width:'1%'}}>
                {row.count_no_null_compid > 0?"\u2b55":"\u2705"}
            </td>            
            <td style={{width:'25%'}}>
                {
                    (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim() + " " +
                    (row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() 
                }
            </td>
            <td className='d-none d-sm-table-cell' style={{width:'25%'}}>
                {row.comentariosdeljuez}    
            </td>                 
            <td className='d-none d-sm-table-cell' style={{width:'25%'}}>
                {((row.arean1experiencia || "") + " - " + (row.arean2experiencia || "")).trim()}
            </td>
            <td className='d-none d-sm-table-cell' style={{width:'25%'}}>
                {row.nombrearea}
            </td>
            </tr>
            </>
        )
        })
        return (
        <>
        <tbody>
            {rows}
        </tbody>
        </>
        )  
    }
    else {
        return null;
    }
}  

  export default AgregarAreaN1;